export default __webpack_public_path__ + "static/agency-user1-0fe6f2c23b964b1fea39ffab40f12d7d.png";